import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import ENV from 'web-app/config/environment';

import {type Event} from './types';

export const track = (events: Event[], token: string, expires: string) => {
    return RESTClient.post(
        'client-events',
        {
            events,
            token,
            expires,
        },
        {
            customApiUrl: ENV.analytics.url,
            suppressErrors: true,
        },
    );
};
